export default {
  nav: {
    home: "Startseite",
    categories: "Kategorien",
    guides: "Ratgeber",
    buyingGuide: "Kaufratgeber",
    faq: "FAQ",
  },
  hero: {
    badge: "Unabhängige AllChinaBuy-Ressource",
    title: "AllChinaBuy Spreadsheet 2026",
    subtitle: "Entdecke organisierte AllChinaBuy-Funde, Produktkategorien, QC-Referenzen, Versand-Guides und praktische Käufer-Ressourcen — alles an einem Ort.",
    ctaSpreadsheet: "allchinabuy spreadsheet",
    ctaBuy: "Jetzt kaufen",
    ctaGuide: "Einsteiger-Guide lesen",
  },
  categories: {
    title: "Spreadsheet-Kategorien durchstöbern",
    subtitle: "Springe direkt zu deiner Lieblings-Produktkategorie im vollständigen Spreadsheet.",
    browse: "Durchstöbern",
    shoes: "Schuhe",
    hoodies: "Hoodies/Sweater",
    tshirts: "T-Shirts",
    jackets: "Jacken",
    pants: "Hosen/Shorts",
    headwear: "Kopfbedeckungen",
    sets: "Sets",
    underwear: "Unterwäsche/Unterhosen",
    jersey: "Trikots",
    accessories: "Accessoires",
    bags: "Taschen",
    belts: "Gürtel",
    perfumes: "Parfums",
    other: "Sonstiges",
  },
  why: {
    title: "Warum das AllChinaBuy Spreadsheet nutzen?",
    subtitle: "Eine einfache, organisierte Möglichkeit, Produkte vor dem Kauf zu recherchieren.",
    f1t: "Organisierte Funde",
    f1d: "Kuratierte Produktlinks nach Kategorie gruppiert, damit du dir stundenlanges Scrollen sparst.",
    f2t: "QC-Referenzen",
    f2d: "Erfahre, worauf du bei Qualitätskontrollfotos vor dem Versand achten solltest.",
    f3t: "Versand-Klarheit",
    f3d: "Verstehe Gewicht, Volumengewicht und wie du Versandkosten senken kannst.",
    f4t: "Anfängerfreundlich",
    f4d: "Klare Schritte, die Erstkäufern helfen, mit Vertrauen zu bestellen.",
  },
  guides: {
    title: "AllChinaBuy-Guides & Artikel",
    subtitle: "Unabhängige, originelle Guides für klügeres Einkaufen.",
    readMore: "Artikel lesen",
  },
  faq: {
    title: "Häufig gestellte Fragen",
    q1: "Was ist das AllChinaBuy Spreadsheet?",
    a1: "Es ist eine von der Community zusammengestellte Sammlung kuratierter Produktlinks und Funde, nach Kategorie organisiert, die Käufern hilft, Artikel zu entdecken und QC- sowie Versanddetails einfacher nachzuschlagen.",
    q2: "Ist diese Seite die offizielle AllChinaBuy-Website?",
    a2: "Nein. Dies ist eine unabhängige Informationsressource und nicht mit AllChinaBuy verbunden. Preise, Versandtarife und Richtlinien können sich ändern — bitte vor dem Kauf prüfen.",
    q3: "Führen die Kategorie-Buttons zum Haupt-Spreadsheet?",
    a3: "Ja. Jeder Kategorie-Button verlinkt auf die entsprechende Kategorie der Haupt-Spreadsheet-Seite.",
    q4: "Brauche ich ein Konto zum Stöbern?",
    a4: "Nein, für die Guides und Kategorie-Links dieser Seite ist kein Konto erforderlich.",
    q5: "Kann ich Versand- und Coupon-Infos vertrauen?",
    a5: "Die Angaben auf dieser Seite dienen nur als Referenz. Bestätige aktuelle Preise, Coupons und Versandtarife immer auf der offiziellen Seite, bevor du bestellst.",
  },
  cta: {
    title: "Bereit, das vollständige Spreadsheet zu entdecken?",
    subtitle: "Besuche die Hauptseite, um das vollständige, stets aktuelle Produkt-Spreadsheet zu durchstöbern.",
    button: "AllChinaBuy Spreadsheet öffnen",
  },
  footer: {
    tagline: "Eine unabhängige Ressource für AllChinaBuy-Käufer.",
    disclaimerTitle: "Haftungsausschluss",
    disclaimer: "Dies ist eine unabhängige Informationsressource und nicht mit AllChinaBuy verbunden. Preise, Versandtarife, Coupons, Verkäufer und Richtlinien können sich ändern. Bitte prüfe aktuelle Informationen vor dem Kauf. Alle externen Links öffnen sich in einem neuen Tab.",
    rights: "© 2026 AllChinaBuy Spreadsheet. Alle Rechte vorbehalten.",
  },
};